import styled from 'styled-components';

export const FinalCronExpression = styled.p`
    font-size: 10px;
    opacity: 0.5;
`;